import classNames from "classnames/bind";
import styles from "./LoadingSpinner.module.sass";

interface LoadingSpinnerProps {
  customClass?: string;
  light?: boolean;
}

export const LoadingSpinner = ({ customClass, light, ...rest }: LoadingSpinnerProps) => {

  const ctx = classNames.bind(styles);
  const loadingSpinnerClass = ctx('spinner', {
    'spinner--white': light,
  });

  return (
    <div className={`${styles.loading_spinner} ${customClass}`} {...rest}>
      <div className={loadingSpinnerClass}></div>
    </div>
  );
};
